import red from 'material-ui/colors/red'
import green from 'material-ui/colors/green'

export default theme => ({

  loading: {
    marginRight: theme.spacing.unit
  },

  error: {
    backgroundColor: `${red[200]} !important`
  },

  success: {
    backgroundColor: `${green[200]} !important`
  }

})



// WEBPACK FOOTER //
// ./src/styles/components/AsyncButton.js